// Curated station video links. Providers may rotate stream IDs or interrupt coverage.
// Verified with actual playback on 2026-10-06; live status remains provider-controlled.
export const LIVE_STREAMS = {
  25544: [
    { label: 'NASA Earth Viewing', url: 'https://www.youtube.com/watch?v=awQzjn72bI0', source: 'youtube.com', publisher: 'NASA', always_on: true },
    { label: 'ISS Live', url: 'https://www.youtube.com/watch?v=M3HKLzjvKPc', source: 'youtube.com', publisher: 'NASA', always_on: true },
    { label: 'NASA live events', url: 'https://www.nasa.gov/live/', source: 'nasa.gov', publisher: 'NASA', always_on: false },
  ],
  // No verified Tiangong live camera: do not substitute an unrelated ISS feed.
};
